import FormField from '../formField';
import SelectFormField from '../selectFormField';

export const inputNames = {
	apartmentId: 'apartmentId', // Not included as a field in the form
	apartmentAddress: 'apartmentAddress',
	addressNumber: 'addressNumber',
	realEstateId: 'realEstateId',
	zipAndLocation: 'zipAndLocation',
	name: 'name',
	ssn: 'ssn',
	address: 'address',
	zip: 'zip',
	email: 'email',
	phone: 'phone',
	cellPhone: 'cellPhone',
	comments: 'comments',
	coTenantName: 'coTenantName',
	coTenantSsn: 'coTenantSsn',
	coTenantEmail: 'coTenantEmail',
	coTenantCellPhone: 'coTenantCellPhone',
	taxReport: 'taxReport',
	cashPaymentOverview: 'cashPaymentOverview',
	submissionArgument: 'submissionArgument',
	creditInfoApproval: 'creditInfoApproval',
	creditRating: 'creditRating',
	debtSummary: 'debtSummary'
};

export const getInitialValues = (apartment, authInfo) => ({
	[inputNames.apartmentId]: apartment.Id,
	[inputNames.apartmentAddress]: apartment.Address,
	[inputNames.addressNumber]: apartment.AddressNumber,
	[inputNames.realEstateId]: apartment.RealEstateId,
	[inputNames.zipAndLocation]: apartment.Zip,
	[inputNames.name]: authInfo.Name,
	[inputNames.ssn]: authInfo.SSN,
	[inputNames.address]: '',
	[inputNames.zip]: '',
	[inputNames.email]: '',
	[inputNames.phone]: '',
	[inputNames.cellPhone]: '',
	[inputNames.comments]: '',
	[inputNames.coTenantName]: '',
	[inputNames.coTenantSsn]: '',
	[inputNames.coTenantCellPhone]: '',
	[inputNames.coTenantEmail]: '',
	[inputNames.creditInfoApproval]: false
});

export const getInitialActiveInputMapper = (initialValues) => {
	const mapper = {};

	Object.keys(initialValues).map((key) => {
		if(initialValues[key] && initialValues[key].length > 0) {
			mapper[key] = true;
		}
	});

	return mapper;
};

export const fields = {
	basicInfo: [
		{
			id: 1, fieldName: inputNames.apartmentAddress, readOnly: true, type: 'text', labelName: 'Götuheiti / Address / Adres'
		},
		{
			id: 2, fieldName: inputNames.addressNumber, readOnly: true, type: 'text', labelName: 'Íbúðarnúmer / Apartment / Numer mieszkania'
		},
		{
			id: 3, fieldName: inputNames.realEstateId, readOnly: true, type: 'text', labelName: 'Fastanúmer / Property / Numer nieruchomości'
		},
		{
			id: 4, fieldName: inputNames.zipAndLocation, readOnly: true, type: 'text', labelName: 'Póstnúmer og staður / Post code and place / Kod pocztowy i miejscowość'
		}
	],
	renterInfo: [
		{
			id: 5, fieldName: inputNames.name, readOnly: true, type: 'text', labelName: 'Fullt nafn / Full name / Imię i nazwisko'
		},
		{
			id: 6, fieldName: inputNames.ssn, readOnly: true, type: 'text', labelName: 'Kennitala / National ID'
		},
		{
			id: 7, fieldName: inputNames.address, readOnly: false, type: 'text', labelName: 'Heimilisfang / Address / Adres zamieszkania'
		},
		{
			id: 8, fieldName: inputNames.zip, readOnly: false, type: 'dropdown', labelName: 'Póstnúmer / Post code / Kod pocztowy'
		},
		{
			id: 9, fieldName: inputNames.email, readOnly: false, type: 'text', labelName: 'Netfang / Email address / Adres mailowy'
		},
		{
			id: 10, fieldName: inputNames.phone, readOnly: false, type: 'text', labelName: 'Símanúmer / Phone number / Numer telefonu'
		},
		{
			id: 11, fieldName: inputNames.cellPhone, readOnly: false, type: 'text', labelName: 'Farsími / Mobile phone number / Telefon komórkowy'
		},
		{
			id: 12, fieldName: inputNames.comments, readOnly: false, type: 'text', labelName: 'Athugasemd / Comments / Dodatkowo'
		}
	],
	additionalRenterInfo: [
		{
			id: 13, fieldName: inputNames.coTenantName, readOnly: false, type: 'text', labelName: 'Fullt nafn meðleigjanda / Co-tenant full name / Imię i nazwisko współlokatora'
		},
		{
			id: 14, fieldName: inputNames.coTenantSsn, readOnly: false, type: 'text', labelName: 'Kennitala meðleigjanda / National ID of co-tenant / Kennitala współlokatora'
		},
		{
			id: 15, fieldName: inputNames.coTenantCellPhone, readOnly: false, type: 'text', labelName: 'Farsími / Mobile phone number / Telefon komórkowy'
		},
		{
			id: 16, fieldName: inputNames.coTenantEmail, readOnly: false, type: 'text', labelName: 'Netfang / Email address / Adres mailowy'
		}
	],
	files: [
		{
			id: 19, fieldName: inputNames.submissionArgument, fileNameBase: 'rokstudningur', readOnly: false, type: 'text', labelName: 'Rökstuðningur/Umsóknarform fyrir Grindvíkinga (PDF) / Reasons for application/Application form for Grindavík / Uzasadnienie/formularz wniosku dla grindawiczanów (PDF)'
		},
	],
	approvals: [
		{
			id: 20, fieldName: inputNames.creditInfoApproval, readOnly: false, type: 'checkbox', labelName: 'Umsækjandi/umsækjendur lýsa því yfir að framlögð gögn sem mat á umsókn byggir á eru rétt og samþykkja einnig að afhenda Leigufélaginu Bríeti ehf. frekari gögn til staðfestingar sé þess óskað. / Applicant(s) hereby state that the forementioned information is correct and agree to supply more documents/information for clarification to Leigufélagið Bríet ehf. should that be requested. / Wnioskodawca/wnioskodawcy oświadczają, że przesłane dane, na których opiera się ocena wniosku, są prawidłowe i wyrażają zgodę na ich przekazanie firmie Leigufélagin Bríeti ehf. dodatkowe dane do potwierdzenia na życzenie.'
		}
	]
};

export const requiredValues = {
	[inputNames.apartmentAddress]: true,
	[inputNames.addressNumber]: true,
	[inputNames.realEstateId]: true,
	[inputNames.zipAndLocation]: true,
	[inputNames.name]: true,
	[inputNames.ssn]: true,
	[inputNames.address]: true,
	[inputNames.zip]: true,
	[inputNames.email]: true,
	[inputNames.phone]: true,
	[inputNames.cellPhone]: true,
	[inputNames.creditInfoApproval]: true
};

// Not in use atm, users should be able to request that Briet accesses
// files themselves if they don't have access to it
export const requiredFiles = {
	[inputNames.submissionArgument]: true,
};

export const fieldTypeMapper = {
	text: FormField,
	dropdown: SelectFormField
};
